import { TImageProps } from "./Image.config";

export const isImage = (image: unknown): image is TImageProps => (
  image !== null && typeof image === "object" && ("src" in image || "srcSet" in image)
);
